import { useNavigate } from 'react-router-dom';
import { usePendingBooking, completeBookingPath } from '../../utils/pendingBooking';
import { formatInr } from '../../utils/pricing';

// Shown on every customer-site page whenever the logged-in visitor has a payment that went through
// but has no session time chosen yet - so "you paid, please come back and finish" is something the
// customer sees wherever they are, not something they have to remember to check My Payments for.
const PendingBookingBanner = () => {
    const { pending } = usePendingBooking();
    const navigate = useNavigate();

    if (!pending) return null;

    return (
        <div className="border-b border-brand-accent/30 bg-brand-accent/15">
            <div className="mx-auto flex w-full max-w-container flex-col gap-2 px-5 py-2.5 text-sm sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-10">
                <span className="text-brand-dark">
                    <strong className="font-semibold">You paid {formatInr(pending.amount)}</strong> and haven&apos;t chosen a session time yet.
                </span>
                <button
                    type="button"
                    className="flex-shrink-0 rounded-none border border-brand-accent bg-brand-accent px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-ground-deep transition hover:opacity-90"
                    onClick={() => navigate(completeBookingPath(pending.orderId))}
                >
                    Complete your booking
                </button>
            </div>
        </div>
    );
};

export default PendingBookingBanner;
